import { createBrowserClient as createEUClient } from "@slardar/web/euttp";
import { createBrowserClient as createVAClient } from "@slardar/web/maliva";
import { createBrowserClient as createUSClient } from "@slardar/web/oci";
import { createBrowserClient as createSGClient } from "@slardar/web/sg";
import { Region, SDK_BID, VERSION } from "../constants/env";
class SlardarContainer {
  constructor(config) {
    this.sendEvent = (data) => {
      if (this._client && this._client.sendEvent) {
        this._client.sendEvent(data);
      }
    };
    this.reportActualFMP = () => {
    };
    const { region, bid: consumerBid, mode } = config;
    switch (region) {
      case Region.US_EASTRED:
      case Region.EU_TTP:
      case Region.EU_TTP2: {
        this._client = createEUClient();
        break;
      }
      case Region.US_TTP:
      case Region.US_TTP2: {
        this._client = createUSClient();
        break;
      }
      case Region.SINGAPORE_CENTRAL: {
        this._client = createSGClient();
        break;
      }
      case Region.US_EAST: {
        this._client = createVAClient();
        break;
      }
      default:
        break;
    }
    if (this._client) {
      this._client("init", {
        bid: SDK_BID,
        pid: consumerBid ? consumerBid : window.location.href,
        release: VERSION,
        env: mode,
        plugins: {
          jsError: false,
          tti: false,
          performance: false,
          resource: false,
          ajax: false,
          fetch: false,
          fmp: false,
          blankScreen: false
        }
      });
      this._client("start");
    }
  }
}
const createSlardarClientAndInit = (config) => {
  let slardarContainer = null;
  try {
    slardarContainer = new SlardarContainer(config);
  } catch (e) {
  }
  return slardarContainer;
};
export {
  createSlardarClientAndInit
};
